export default "__VITE_ASSET__D7W$sSq8__"